import { Link, useLocation } from "react-router-dom";
import { Typography } from "@/components/atoms";
import { getPhpHostUrl } from "@/helpers/apiHelpers";
import { clsx } from "@/utils";
import { useExternalSupplierProfileProfileContext } from "../MyExternalSuppliers/ExternalSupplierProfile/context";

export const ExternalSupplierNavigation = () => {
  const { externalSupplier } = useExternalSupplierProfileProfileContext();
  const { pathname } = useLocation();

  return (
    <div className="flex w-[280px] shrink-0 flex-col gap-1.5 p-2.5">
      <Link to="../profile">
        <Typography
          className={clsx(
            "w-full rounded-lg p-2.5 font-medium",
            pathname.includes("profile") ? "bg-primary-light text-primary" : "text-neutral-black"
          )}
        >
          External Supplier Profile
        </Typography>
      </Link>
      <a href={`${getPhpHostUrl()}/driver/${externalSupplier.id}/profile/`} target="_blank" rel="noreferrer">
        <Typography className={clsx("neutral-black w-full rounded-lg p-2.5 font-medium")}>Legacy Profile</Typography>
      </a>
    </div>
  );
};
